<template>
  <v-container fluid class="px-0 py-0">
    <v-row class="py-3" no-gutters>
      <v-chip v-for="(unit, index) in unitsToEdit" :key="index" class="mr-2">
        {{ `Loja ${unit.id_erp} - ${unit.name}` }}
      </v-chip>
    </v-row>
    <sortable-highlighted-offers :type="type" />
    <clickable-offers-table :type="type" />

    <mf-action-buttons
      class="mt-3"
      :primary-button="{
        text: 'Salvar',
        action: confirm,
        isVisible: true,
        isLoading: loading,
      }"
      :cancel-button="{
        text: 'Cancelar',
        action: cancel,
        isVisible: true,
      }"
    />
  </v-container>
</template>

<script>
import Swal from 'sweetalert2'
import { SET_HIGHLIGHT_SALES } from '../../graphql'
export default {
  components: {
    ClickableOffersTable: () => import('@/modules/mobile/ofertas/views/components/ClickableOffersTable.vue'),
    SortableHighlightedOffers: () => import('@/modules/mobile/ofertas/views/components/SortableHighlightedOffers.vue'),
  },
  data: () => ({
    loading: false,
  }),
  computed: {
    unitsToEdit() {
      return this.$store.getters.selectedUnits
    },
    highlightedOffers() {
      return this.$store.getters.highlightedOffers
    },
    type() {
      return this.$route.params.type
    },
  },
  created() {
    if (!this.unitsToEdit.length || !this.type) this.$router.push('/mobile/ofertas/destaques')
  },
  methods: {
    cancel() {
      this.$store.commit('SET_HIGHLIGHTED_OFFERS', [])
      this.$router.push('/mobile/ofertas/destaques')
    },
    async confirm() {
      this.loading = true
      try {
        await this.$apollo.mutate({
          mutation: SET_HIGHLIGHT_SALES,
          variables: {
            sales_ids: this.highlightedOffers.map((offer) => offer._id),
            app_units: this.unitsToEdit.map((unit) => unit.id_erp),
            activatable: this.type === 'ativaveis',
          },
        })

        this.loading = false
        Swal.fire({
          text: 'Destaques salvos com sucesso!',
          icon: 'success',
          showConfirmButton: false,
          timer: 1000,
          customClass: {
            content: 'content-class',
          },
        })
        this.$store.commit('SET_HIGHLIGHTED_OFFERS', [])
        this.$router.push('/mobile/ofertas/destaques')
      } catch (error) {
        console.error(error)
        this.loading = false
        Swal.fire({
          text: 'Erro ao salvar ofertas em destaque.',
          icon: 'error',
          showConfirmButton: false,
          timer: 1000,
          customClass: {
            content: 'content-class',
          },
        })
      }
    },
  },
}
</script>
